import { render, staticRenderFns } from "./core_quote.vue?vue&type=template&id=697448f0&scoped=true"
import script from "./core_quote.vue?vue&type=script&lang=js"
export * from "./core_quote.vue?vue&type=script&lang=js"
import style1 from "./core_quote.vue?vue&type=style&index=1&id=697448f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697448f0",
  null
  
)

export default component.exports